import { Page } from '@/core/architecture'

import { NotFoundTemplate } from './template'

type Props = {
  /**
   * default: true
   * useNextRouter = true when this component use for nextjs page
   * useNextRouter = false when this component use inside react-route-dom
   */
  useNextRouter?: boolean
}

/**
 * NotFound Page
 * Implemented as a practical sample.
 */
export const NotFound: Page<Props> = ({ useNextRouter = true }) => {
  return <NotFoundTemplate state={{ useNextRouter }} />
}
